import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './RidgeGourdPage.css';
import ridgegourdLogo from '../images/ridgegourd-logo.png';
import ananth from '../images/ridgegourd-ananth-img.png';
import rathna702 from '../images/ridgegourd-rathna702-img.png';

const varieties = [
  {
    name: 'ANANTH',
    image: ananth,
    description: [
      'Mid early hybrid with prolific bearing',
      'Green fruits with prominent ridges, excellent setting',
      'Fruit length about 30-40 cm, diameter 4-5.5 cm, weighs around 200 gm',
      'Matures around 45 days after planting with tender white flesh',
      'Good keeping quality',
    ],
  },
  {
    name: 'RATHNA-702',
    image: rathna702,
    description: [
      'Mid early hybrid with high vigour and prolific bearing',
      'Green fruits with uniform shape and size',
      'Fruits are 45-50 cm long, tender, weighs about 200-250 gm',
      'Matures in about 45 days with very good keeping quality and transportability',
    ],
  },
 
];

export default function RidgeGourdPage() {
  return (
    <ProductPatternPage
      title="Ridge Gourd"
      varieties={varieties}
      pageClass="ridgegourd-page"
      heroImage={ridgegourdLogo}
    />
  );
}
